export const INVOICE_COUNTRIES = [
  "Canada",
  "United Kingdom",
  "Japan",
  "Arab Emirates",
  "Saudi Arabia",
  "Australia",
  "Singapore",
  "Mexico",
  "Netherlands",
  "Sweden",
  "Belgium",
  "Germany"
];
